export default "__VITE_ASSET__Dhzpkt_V__"